<template>
	<div class="doc-category-card" @click="$emit('click')">
		<div class="card-illustration">
			<img :src="illustration" :alt="label" class="card-illustration-img" />
		</div>
		<div class="card-text">
			<p class="card-label">{{ label }}</p>
			<div class="card-footer">
				<p class="card-count">{{ count || 'No documents yet' }}</p>
				<img :src="require('@/assets/arrow-right.png')" class="card-arrow" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DocCategoryCard',
	emits: ['click'],
	props: {
		label: {
			type: String,
			required: true,
		},
		illustration: {
			type: String,
			required: true,
		},
		count: {
			type: String,
			default: null,
		},
	},
};
</script>

<style scoped>
.doc-category-card {
	border-radius: 8px;
	overflow: hidden;
	background: white;
}

.card-illustration {
	width: 100%;
	aspect-ratio: 16 / 9;
	overflow: hidden;
}

.card-illustration-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

.card-text {
	padding: 8px;
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.card-label {
	font-size: 13px;
	font-weight: bold;
	color: var(--brand-purple);
	margin: 0;
	line-height: 1.2;
}

.card-footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.card-count {
	font-size: 11px;
	color: var(--light-text-secondary);
	margin: 0;
}

.card-arrow {
	width: 16px;
	height: 12px;
}
</style>
